module.exports = __webpack_public_path__ + "img/Icon_transportacion_becas.fd446ea1.svg";